import { render, staticRenderFns } from "./MarketplaceCheckoutStepPayment.vue?vue&type=template&id=65378c22&scoped=true"
import script from "./MarketplaceCheckoutStepPayment.vue?vue&type=script&lang=js"
export * from "./MarketplaceCheckoutStepPayment.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceCheckoutStepPayment.vue?vue&type=style&index=0&id=65378c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65378c22",
  null
  
)

export default component.exports